// World 8 (Halcyon) — fourth paid-tier world. First world to ship at the
// solver's actual deep ceiling: L1-L5 are d=8 openers (branching 17-24,
// mix of r=3 and r=4 geometry); L6-L10 are d=9 climax on r=3 tile-13
// boards (branching 20-25). This is the depth-ramp the design doc
// originally called for — enabled by the v0.4.4 solver heuristic
// tightening (per-color lower bound) which made d=8/9 proofs ~6× faster.
// Generator: tools/generate-parallel.mjs --world 8. Seed 0xaebc9000.
// 73 candidates pooled across 4 configs in 13968s (~3.9h walltime,
// 4-worker pool at 180s solver budget).
import type { LevelDef } from '@tessera/engine';
import { WORLD_8_GENERATED } from './world8-generated';

export const WORLD_8_LEVELS: LevelDef[] = [...WORLD_8_GENERATED];
